import { render } from "./Revenue.vue?vue&type=template&id=30bcb655&scoped=true"
import script from "./Revenue.vue?vue&type=script&lang=js"
export * from "./Revenue.vue?vue&type=script&lang=js"

import "./Revenue.vue?vue&type=style&index=0&id=30bcb655&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bcb655"]])

export default __exports__